<template>
  <div>
    <div class="template-history-card">
      <div class="card-padding d-block d-md-flex align-items-center">
        <span class="text-semibold-black font-size-16">
          {{ templateDetail.templateName }}
        </span>
        <div class="d-flex mt-1 mt-md-0">
          <b-badge
            pill
            :variant="badgeVariant(templateDetail.status)"
            class="ml-0 ml-md-1 font-9px"
            >{{ badgeStatus(templateDetail.status) }}
          </b-badge>
          <span
            @click="goToTemplateDetail"
            class="menu-link ml-1 d-none d-md-flex"
          >
            Escalation Detail
          </span>
          <span
            @click="goToTemplateDetail"
            class="menu-link ml-1 d-flex d-md-none"
          >
            Detail
          </span>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            hover
            :items="items"
            :fields="fields"
            @row-clicked="selectRow"
          >
            <template #cell(level)="data"
              ><span class="text-semibold-black">
                LEVEL {{ data.value }}
              </span></template
            >
            <template #cell(escalationDate)="data">
              <div class="d-flex">
                <span>
                  {{ data.item.escalationDate.date }}
                </span>
              </div>
              <div>
                <span class="text-regular-grey font-size-12">
                  {{ data.item.escalationDate.time }}
                </span>
              </div>
            </template>
            <template #cell(issueId)="data">
              <div class="d-flex">
                <span class="text-medium-black">
                  {{ data.item.issueId.ntdcId }}
                </span>
              </div>
              <div>
                <span class="text-color-grey">
                  {{ data.item.issueId.ticketId }}
                </span>
              </div>
            </template>
            <template #cell(escalateBy)="data">
              <div class="d-flex">
                <span class="text-semibold-black">
                  {{ data.item.escalateBy.name }}
                </span>
              </div>
              <div>
                <span> ({{ data.item.escalateBy.role }}) </span>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
        <div class="col-6 d-flex justify-content-end">
          <b-pagination
            v-model="filterList.currentPage"
            :total-rows="filterList.totalCount"
            :per-page="10"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>
      </div>
    </div>
    <footer style="padding-top:21px;"></footer>
  </div>
</template>

<script>
import { BBadge, BTable, BPagination } from "bootstrap-vue"
import mixinsDatetime from "@/mixins/mixinsDatetime"

export default {
  name: "OrganismTemplateHistory",
  components: {
    BBadge,
    BTable,
    BPagination,
  },
  props: {
    templateDetail: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterList: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {}
  },

  mounted() {},

  methods: {
    badgeVariant(status) {
      if (status.toLowerCase() === "active") return "light-success"
      else return "light-secondary"
    },

    badgeStatus(status) {
      if (status.toLowerCase() === "active") return "Active"
      else return "Suspended"
    },

    goToTemplateDetail() {
      const templateId = this.templateDetail.templateId
      this.navigateTo(`/internal/web-portal/escalation/${templateId}`)
    },

    selectRow(row){
      const ticketId = row.issueId.ticketId
      this.navigateTo(`/internal/web-portal/ticket/${ticketId}`)
    },

    navigateTo(path) {
      this.$router.push(path)
    },
  },
}
</script>

<style lang="scss" scoped>
.template-history-card {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.card-padding {
  padding: 21px;
}

.menu-link {
  padding-top: 3px;
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #7367f0;
  }
}
</style>
